import type {
  NextPage,
  GetStaticPropsContext,
} from 'next'
import reverse from 'lodash/reverse'
import Head from 'next/head'
import { Layout, Main } from 'layout'
import {
  BlogAll,
} from 'Blog'
import {
  ENTRIES
} from 'BlogEntries'

const BLOG_ENTRIES = reverse(ENTRIES)

const Blog: NextPage<unknown> = () => (
  <Layout>
    <Head>
      <title>Blog | FrauenCoach</title>
      <meta name="description" content={`Lebensfragen klären - Krisen meistern ● Ihr Coach ● Kein Risiko, nachhaltig und individuell ● Identität, Beziehungen, Gesundheit, Balance, Selbstbestimmung`} />
    </Head>
    <Main>
      <BlogAll blogEntries={BLOG_ENTRIES} />
    </Main>
  </Layout>
)

export function getStaticProps(
  _context: GetStaticPropsContext
) {
  return {
    props: {}
  }
}

export default Blog


